import { Flex, type FlexProps, Icon, Link, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@icons";
import { useColor } from "@styles/useColor";
import { formatPkh } from "@umami/chains";
import { memo } from "react";

export const AddressPill = memo(
  ({ address, explorerUrl, ...props }: { address: string; explorerUrl: string } & FlexProps) => {
    const color = useColor();

    return (
      <Flex
        as={Link}
        alignItems="center"
        justifyContent="space-around"
        width="fit-content"
        background={color("100")}
        borderRadius="full"
        _hover={{ background: color("200", "300"), textDecoration: "none" }}
        cursor="pointer"
        href={explorerUrl}
        isExternal
        paddingY="3px"
        {...props}
      >
        <Text color={color("700")} fontSize="sm" lineHeight="18px" marginX="10px">
          {formatPkh(address)}
        </Text>
        <Icon as={ExternalLinkIcon} marginRight="10px" marginLeft="-4px" color={color("700")} />
      </Flex>
    );
  }
);
